import { Configuration } from '../app.constants'
import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'

@Injectable()
export class TagService {
    constructor(private http: HttpClient) {
    }

    getByTag(tag: string): any {
        return this.http.get(Configuration.apiUrl + 'Api/Dashboard/AdminGetByTag?tag=' + tag)
    }

    getAllByTag(tag): any {
        return this.http.get(Configuration.apiUrl + 'Api/Tag/GetAllByTag?tag=' + tag)
    }

    getAllByStoreUrl(storeUrl): any {
        return this.http.get(Configuration.apiUrl + 'Api/Tag/GetAllByStoreUrl?storeUrl=' + storeUrl)
    }

    getStoreByTag(tag): any {
        return this.http.get(Configuration.apiUrl + 'Api/Tag/GetStoreByTag?tag=' + tag)
    }

    add(tag, name, storeUrl): any {
        var model = { tag, name, storeUrl };
        return this.http.post(Configuration.apiUrl + 'Api/Tag/Add', model, {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    addCombo(tag, name, storeUrlList): any {
        var model = { tag, name, storeUrlList };
        //return this.http.post(Configuration.apiUrl + 'Api/Tag/AddCombo?tag=' + tag + '&name=' + name + '&storeUrlList=' + storeUrlList, null, {
        return this.http.post(Configuration.apiUrl + 'Api/Tag/AddCombo', model, {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    removeCombo(tag, name, storeUrlList): any {
        var model = { tag, name, storeUrlList };
        //return this.http.post(Configuration.apiUrl + 'Api/Tag/AddCombo?tag=' + tag + '&name=' + name + '&storeUrlList=' + storeUrlList, null, {
        return this.http.post(Configuration.apiUrl + 'Api/Tag/DeleteCombo', model, {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    deleteLink(tag, storeUrl): any {
        return this.http.get(Configuration.apiUrl + 'Api/Tag/DeleteLink?tag=' + tag + '&storeUrl=' + storeUrl)
    }

    deleteAllLink(tag): any {
        return this.http.get(Configuration.apiUrl + 'Api/Tag/DeleteAllLink?tag=' + tag)
    }

}